import { motion } from "framer-motion";

// Scroll-triggered reveal wrapper.
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal (each line slides up from behind a mask).
// Extra padding keeps Devanagari matras/descenders from being clipped by overflow.
export const MaskLine = ({ children, delay = 0, className = "", load = true }) => {
  const inner = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] } },
  };
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block py-[0.12em] pr-[0.08em]"
        variants={inner}
        initial="hidden"
        animate={load ? "show" : undefined}
        whileInView={load ? undefined : "show"}
        viewport={{ once: true }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08 } },
};

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};
